import React from "react";
import { Container, Row, Col } from "reactstrap";
import { IoTicketSharp } from "react-icons/io5";
import { FaCalendarAlt } from "react-icons/fa";
import { ReactComponent as FAQs } from '../../../../assets/fonts/faqsvg.svg'

export default function HeroSupportTickets() {
  const card = {
    height: "165px",
    width: "270px",      // fixed card width
    backgroundColor: "white",
    borderRadius: "24px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "24px",
  };

  return (
    <Container fluid className="px-3">
      {/* blue banner */}
      <Row className="justify-content-center">
        <Col xs="12">
          <div
            style={{
              backgroundColor: "#091954",
              borderRadius: "24px",
              padding: "70px 20px 140px",
              textAlign: "center",
            }}
          >
            <h1 style={{ fontSize: 48, color: "#FDFEFF" }}>
              Need our help? We’ve got your back
            </h1>
          </div>
        </Col>
      </Row>

      {/* cards row with tighter gap */}
      <Row
        className="justify-content-center gx-2 gy-3" // ⬅️ 8 px horizontal gutter
        style={{ marginTop: "-100px" }}
      >
        <Col xs="10" sm="6" md="auto" className="d-flex justify-content-center">
          <div style={card}>
            <IoTicketSharp style={{ fontSize: 67, color: "#091954" }} />
            <h2 style={{ fontSize: 24, textAlign: "center", margin: 0 }}>
              Generate Support Ticket
            </h2>
          </div>
        </Col>

        <Col xs="10" sm="6" md="auto" className="d-flex justify-content-center">
          <div style={card}>
            <FaCalendarAlt style={{ height: 81, width: 81, color: "#091954" }} />
            <h2 style={{ fontSize: 24, textAlign: "center", margin: 0 }}>
              Schedule a Meeting Now
            </h2>
          </div>
        </Col>

        <Col xs="10" sm="6" md="auto" className="d-flex justify-content-center">
          <div style={card}>
            <FAQs style={{ fontSize: 67, color: "#091954" }} />
            <h2 style={{ fontSize: 24, textAlign: "center", margin: 0 }}>
              FAQ
            </h2>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
